const sections = [
  {
    number: '01',
    icon: 'ri-funds-box-line',
    title: 'Колоссальная экономия ресурсов',
    color: '#C5A880',
    items: [
      {
        icon: 'ri-money-dollar-circle-line',
        title: '-90% расходов на продакшн (производство)',
        text: 'Забудьте об аренде студий, оплате операторов, монтажёров и гримёров. Создание видео теперь стоит в разы дешевле.',
      },
      {
        icon: 'ri-time-line',
        title: 'Экономия 80% времени эксперта',
        text: 'Вам больше не нужно тратить целые дни на съёмки. Один раз создаём «клон» — и он генерирует сотни роликов, пока вы занимаетесь стратегией.',
      },
      {
        icon: 'ri-rocket-line',
        title: 'Мгновенное масштабирование',
        text: 'Выпускайте десятки роликов в неделю, а не один в месяц. Ваша контент-машина теперь работает со скоростью мысли.',
      },
    ],
  },
  {
    number: '02',
    icon: 'ri-global-line',
    title: 'Безграничный охват',
    color: '#3A6B9F',
    items: [
      {
        icon: 'ri-earth-line',
        title: 'Выход на международные рынки',
        text: 'Ваш аватар заговорит на 20+ языках (турецком, английском, немецком и др.) с сохранением вашего уникального голоса.',
      },
      {
        icon: 'ri-24-hours-line',
        title: '24/7 присутствие',
        text: 'Ваш цифровой двойник может одновременно «выступать» на вебинаре, приветствовать клиента на сайте и продавать в личной рассылке.',
      },
    ],
  },
  {
    number: '03',
    icon: 'ri-shield-star-line',
    title: 'Повышение лояльности (Trust Factors)',
    color: '#5E8A5E',
    items: [
      {
        icon: 'ri-mail-send-line',
        title: 'Ответы на 30–40% чаще',
        text: 'Личные видео-сообщения в «холодных» продажах открывают двери, которые раньше были закрыты для обычных писем.',
      },
      {
        icon: 'ri-award-line',
        title: 'Статус технологического лидера',
        text: 'Вы используете технологии 2026 года, что автоматически выделяет вас на фоне конкурентов и повышает ценность вашего бренда в глазах клиентов.',
      },
    ],
  },
];

export default function AIAvatarWhy() {
  return (
    <section className="py-14 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section header */}
        <div className="text-center mb-10 sm:mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-question-answer-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Зачем это вашему бизнесу
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-5 leading-tight">
            Почему вашему бизнесу нужен ИИ-Аватар?
          </h2>
          <p className="text-gray-600 font-['Montserrat'] text-sm sm:text-base max-w-2xl mx-auto leading-relaxed text-center">
            Для многих экспертов видео-контент — это «боль»: нужно выставить свет, настроить звук, сделать макияж, выучить текст и не запинаться.
          </p>
          <p className="font-['Montserrat'] text-sm sm:text-base max-w-2xl mx-auto leading-relaxed text-center mt-4">
            <strong className="text-[#1A2B4C]">С ИИ-аватаром всё меняется:</strong>
          </p>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mt-6"></div>
        </div>

        <div className="space-y-6 sm:space-y-14">
          {sections.map((sec) => (
            <div key={sec.number} className="bg-[#F9F5EF] rounded-2xl sm:rounded-3xl p-5 sm:p-10 border border-[#E8DDD0]">
              {/* Section title */}
              <div className="flex items-center gap-3 sm:gap-4 mb-5 sm:mb-8">
                <div className="w-11 h-11 sm:w-12 sm:h-12 flex items-center justify-center rounded-xl bg-[#1A2B4C] flex-shrink-0">
                  <i className={`${sec.icon} text-xl sm:text-2xl text-[#C5A880]`}></i>
                </div>
                <div>
                  <span className="text-xs text-[#C5A880] font-bold font-['Montserrat'] uppercase tracking-wider">
                    {sec.number}
                  </span>
                  <h3 className="text-base sm:text-2xl font-bold text-[#1A2B4C] font-['Playfair_Display'] leading-snug">
                    {sec.title}
                  </h3>
                </div>
              </div>

              {/* Items grid */}
              <div className={`grid grid-cols-1 ${sec.items.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'} gap-3 sm:gap-6`}>
                {sec.items.map((item) => (
                  <div key={item.title} className="bg-white rounded-xl p-4 sm:p-6 border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300">
                    <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center rounded-lg bg-[#1A2B4C]/08 mb-3 sm:mb-4">
                      <i className={`${item.icon} text-base sm:text-lg text-[#C5A880]`}></i>
                    </div>
                    <h4 className="text-sm sm:text-base font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-2 leading-snug">
                      {item.title}
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] text-justify">
                      {item.text}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
